const layouts = {}

const requireContext = require.context('./', false, /.*\.vue$/)
requireContext.keys().forEach( file => {
    const component = requireContext(file).default
    if (component && component.name)
    {
        layouts[component.name] = component
    }
})

export default layouts
